export const FANTRAX_API = 'Fantrax';
export const YAHOO_FANTASY_API = 'Yahoo! Fantasy Sports';

export const getAttachedFantasyDataset = (dataSpace) =>
	dataSpace?.datasets?.find((dataset) => [YAHOO_FANTASY_API, FANTRAX_API].includes(dataset.tags?.api));

export const getFantraxLeagueDisplayName = (fantasyLeague) => {
	if (fantasyLeague?.api !== FANTRAX_API) {
		return fantasyLeague?.displayName;
	}

	if (fantasyLeague.seasonYear) {
		return `${fantasyLeague.name || fantasyLeague.leagueName} (${fantasyLeague.seasonYear}) - Fantrax ${
			fantasyLeague.sport
		}`;
	}

	return fantasyLeague.displayName;
};

export const isEditFantasyLeagueOptionDisabled = ({
	fantasyLeague,
	selectedFantasyLeague,
	selectedSport,
	attachedFantasyDataset,
}) => {
	const attachedApi = selectedFantasyLeague?.api || attachedFantasyDataset?.tags?.api;
	const attachedSport = selectedFantasyLeague?.sport || attachedFantasyDataset?.tags?.sport;
	const attachedFantraxLeagueId =
		selectedFantasyLeague?.leagueId ||
		(attachedFantasyDataset?.tags?.api === FANTRAX_API ? attachedFantasyDataset.leagueKey : undefined);

	// The attached Fantrax league stays selectable so choosing it refreshes the league
	// and pulls the current season. Yahoo disable rules are unchanged.
	if (
		fantasyLeague.api === FANTRAX_API &&
		attachedFantraxLeagueId != null &&
		String(fantasyLeague.leagueId) === String(attachedFantraxLeagueId)
	) {
		return false;
	}

	if (attachedApi && attachedSport) {
		return fantasyLeague.api !== attachedApi || fantasyLeague.sport !== attachedSport;
	}

	if (selectedSport) {
		return fantasyLeague.sport !== selectedSport;
	}

	return false;
};
